import React from "react";
import { ReservationTemplate } from "../../components/templates";

function Reservation() {
  return <ReservationTemplate />;
}

export default Reservation;
